import AccountDeleteFieldset from '@/components/pages/Profile/fieldsets/AccountDelete';
import AccountLeaveFieldset from '@/components/pages/Profile/fieldsets/AccountLeave';
import { useAccount } from '@/hooks/useAccount';
import { RoleType } from '@/shared/types/member';

export const DangerSection = () => {
  const { slug, accountRole } = useAccount();

  if (!accountRole) {
    return null;
  }

  return accountRole === RoleType.OWNER ? (
    <AccountDeleteFieldset key={slug} />
  ) : (
    <AccountLeaveFieldset key={slug} />
  );
};
